/**
 * 生成 RFC4122 v4 形状的 UUID，替代 uuid 依赖。
 *
 * 输出与 `uuid` 包的 `v4()` 完全同构：
 *   xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 *   - 第 15 位固定为 "4"（版本位）
 *   - 第 20 位为 "8/9/a/b" 之一（variant 10xx）
 *
 * 随机源策略：
 *   - 优先 `crypto.getRandomValues`（所有 browserslist 目标都支持：
 *     Chrome 43+ / iOS 10+ / Android 4.4+，以及 Node 19+ 全局 webcrypto），
 *     提供 122 位有效熵，碰撞概率可忽略。
 *   - 不支持时降级 `Math.random`，熵略低但格式不变，仍满足 SDK 内部使用。
 */

const HEX = "0123456789abcdef"

const cryptoRef: Crypto | undefined = (() => {
  const g: any =
    typeof globalThis !== "undefined"
      ? globalThis
      : typeof self !== "undefined"
        ? self
        : undefined
  const c = g && (g.crypto || g.msCrypto)
  return c && typeof c.getRandomValues === "function" ? c : undefined
})()

export function uid(): string {
  const b = new Uint8Array(16)
  if (cryptoRef) {
    cryptoRef.getRandomValues(b)
  } else {
    for (let i = 0; i < b.length; i++) {
      b[i] = (Math.random() * 256) & 0xff
    }
  }
  // version 位强制为 4；variant 位强制为 10xx，符合 RFC4122 v4
  b[6] = (b[6] & 0x0f) | 0x40
  b[8] = (b[8] & 0x3f) | 0x80

  let out = ""
  for (let i = 0; i < 16; i++) {
    out += HEX[b[i] >>> 4] + HEX[b[i] & 0x0f]
    if (i === 3 || i === 5 || i === 7 || i === 9) out += "-"
  }
  return out
}
